import type { ComponentProps } from "react";

import { Button } from "~/shared";
import { tw } from "~/utils";

type StaffBookingFooterProps = (
  | { onCancel: () => void; onBack?: never }
  | { onBack: () => void; onCancel?: never }
) & {
  continueProps?: ComponentProps<typeof Button>;
  continueLabel?: string;
  sticky?: boolean;
  backDisabled?: boolean;
};

export const StaffBookingFooter = ({
  onCancel,
  onBack,
  continueProps,
  continueLabel = "Continue",
  sticky = true,
  backDisabled = false,
}: StaffBookingFooterProps) => (
  <div
    className={tw(
      "mt-auto flex gap-4 bg-white pt-6",
      sticky && "sticky bottom-0",
    )}
  >
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="flex-1"
      disabled={backDisabled}
      onClick={onBack ?? onCancel}
    >
      {onBack ? "Back" : "Cancel"}
    </Button>
    {continueProps && (
      <Button size="sm" className="flex-1" {...continueProps}>
        {continueLabel}
      </Button>
    )}
  </div>
);
